import "react-app-polyfill/stable";
import "react-app-polyfill/ie11";
import "fast-text-encoding";
import React from "react";
import ReactDOM from "react-dom";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import LogRocket from "logrocket";
if (process.env.NODE_ENV === "production") {
  LogRocket.init("fyqxo2/video-conference-jq8ao");
}

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
